export default "__VITE_ASSET__Bz$Xo9SC__"